import React from 'react';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import {ExpandMore} from '@mui/icons-material';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, useMediaQuery } from '@mui/material';
import { useLocation, useParams } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import { useCompanyData } from '../contexts/DataContext';
import { textClasses } from '../../shared/config';

const useStyles = makeStyles({
    menuList:{
        padding:'0px'
    },

    menuItem:{
      padding: '8px 11px',
      width: 'auto',
      color: '#000',
      height: '100%',
      cursor:'pointer',

      "@media (max-width:992px)": {
        padding: '8px 0px',
      },
    },

    navItem:props => ({
        '&:hover':{
          color: `${props?.menuActiveFontColor} !important`
        },
    }),

    menuSubItem: props=> ({
        '&:hover':{
            color: `${props?.menuActiveFontColor} !important`,
            backgroundColor:'rgba(0,0,0,0.05)',
        },
        '&:focus':{
            color: `${props?.menuActiveFontColor} !important`,
            backgroundColor:'rgba(0,0,0,0.05)',
        },
    })
});

const StyledMenuItem = withStyles((theme) => ({
    root: {
      borderBottom: '1px solid #eeeeee',
      padding: '15px 30px',
      '& .MuiListItemText-primary': {
        color: '#120d45',
        fontWeight: 500,
      },
    },
}))(MenuItem);

export default function DropdownMenuItem(props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const closeTimerRef = React.useRef(null);

  const { data } = useCompanyData();
  const { defaultColor, activeColor, hasActiveBorderTop, hasActiveBorder, menuFontColor, title,externalLink, to, subMenu, menuActiveFontColor, isMobile, setIsOpen, index, callback } = props;
  const classes = useStyles({menuActiveFontColor,activeColor});
  const location = useLocation();  
  const {id: pathId} = useParams();
  const matches992 = useMediaQuery('(max-width:992px)');
  const { t, fontFamily, companyDomain, history, isRTL, buttonFontSize } = data || {};
  const url = location.pathname; 
  const pathname = window?.location?.pathname;
  const pathSplit = pathname?.split('/');
  const fontSizeCls = buttonFontSize && textClasses?.[buttonFontSize] ? textClasses?.[buttonFontSize] : 'normal';


  const handleClose = (event) => {
    // Clear any existing close timers
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }

    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };


  const handleMouseEnter = () => {
    // Cancel any scheduled close actions
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    // Set a delay before closing the menu
    closeTimerRef.current = setTimeout(() => {
      setOpen(false);
    }, 200); // Adjust the delay as needed
  };

  const clickEvent = async () => {
    if(callback) callback();
    if(externalLink) window.open(externalLink);
    if(to) history.push(to);
  }

  const redirectEvent = async (externalLink,linkPath) => {
    if(callback) callback();
    if(externalLink) window.open(externalLink);
    if(linkPath) history.push(linkPath);
    if(matches992) {
        if(setIsOpen) setIsOpen(false);
    };

  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

    const serviceId = location?.pathname?.split('/services/')[1];
    const categoryId = location?.pathname?.split('/categories/')[1];

    const isActive =
        location.pathname === to ||
        (location.pathname.search(`/services/${serviceId}`) !== -1 &&
        to.search(`/services/${serviceId}`) !== -1);

    const SubMenuItem = (menuItem) => {
        const { englishName, arabicName, visible, externalLink, path,subMenu } = menuItem;

        const linkPath = path ? companyDomain ? `/temp/${path}` : `/${pathId}/temp/${path}` : '';
        const title = isRTL === 'ar' ? arabicName : englishName;
        const isActive =
        location.pathname === linkPath ||
        (location.pathname.search(`/services/${serviceId}`) !== -1 &&
        to.search(`/services/${serviceId}`) !== -1) || (location.pathname.search(`/categories/${categoryId}`) !== -1 &&
        to.search(`/categories/${categoryId}`) !== -1);
        
        if(visible) return <StyledMenuItem classes={{root:`${classes.menuSubItem} ${fontSizeCls}`}} style={isActive ? {color:menuActiveFontColor,backgroundColor:"rgba(0,0,0,0.05)"} : {}} onClick={()=> redirectEvent(externalLink ? externalLink : null,linkPath)}>{title}</StyledMenuItem>;
    };

  return (
    <Box style={{
      ...(matches992 ? 
        {
          width:'100%',
          borderBottom:'1px solid #E5E5E5'
      } : 
      {
        borderTop:  hasActiveBorderTop && isActive ? `4px solid ${menuActiveFontColor ? menuActiveFontColor : activeColor || menuFontColor}` : '',
        borderBottom:  hasActiveBorder && isActive ? `2px solid ${menuActiveFontColor ? menuActiveFontColor : activeColor || menuFontColor}` : '',
      })
    }}
    {...(!matches992 ? { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave } : {})}
    mr={matches992 ? 0 : '10px'}
    whiteSpace="nowrap"
    id={`menu-item-${index}`}
    >
      <Button
        className={`${classes.menuItem} ${classes.navItem} ${fontSizeCls}`}
        ref={anchorRef}
        aria-controls={open ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        style={{
          color: matches992 ? '#000' : isActive ? menuActiveFontColor ? menuActiveFontColor : activeColor : (menuFontColor || defaultColor),
        }}
      >
        <Box
            fontWeight={500}
            style={{cursor:'pointer'}}
            onClick={clickEvent}
        >
            {title}
        </Box>
        {matches992 ? <ExpandMore  style={{paddingLeft:'10px',cursor:'pointer'}} onClick={handleMouseEnter} /> : null}
      </Button>
          {!matches992 ?
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1500 }}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper style={matches992 ? {boxShadow:'none'} : {}}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList classes={{root:classes.menuList}} autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                  {React.Children.toArray(subMenu.map(SubMenuItem))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
          </Popper>
          :
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{ zIndex: 1500, position: 'unset',...(isRTL === 'ar' ? {marginRight:'auto'} : {marginLeft:'auto'}), width:'90%'}}>
            <Paper style={matches992 ? {boxShadow:'none'} : {}}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList classes={{root:classes.menuList}} autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                {React.Children.toArray(subMenu.map(SubMenuItem))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Popper>
          }
    </Box>
  );
}